<div class="ifAuthenticated" *ngIf="isAuthenticated">
  <div [className]="menuIsActive ? 'menu show' : 'menu hide'">
    <div [className]="canHide ? 'hideMenu show' : 'hideMenu hide'" (click)="hideMenu()">
      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve">
        <g>
          <g>
            <path d="M336.226,209.591l-204.8-204.8c-6.78-6.548-17.584-6.36-24.132,0.42c-6.388,6.614-6.388,17.099,0,23.712l192.734,192.734
              L107.294,414.391c-6.663,6.664-6.663,17.468,0,24.132c6.665,6.663,17.468,6.663,24.132,0l204.8-204.8
              C342.889,227.058,342.889,216.255,336.226,209.591z"/>
          </g>
        </g>
      </svg>
    </div>
    <div class="title" routerLink="/">
      Tableau de bord
    </div>
    <div class="sidebar-menu">
      <div class="contenus">
        <div class="title">
          Mes contenus
        </div>
        <ul>
          <li>
            <a style="cursor:pointer;" routerLink="/circuits" routerLinkActive="active">
              Circuits
            </a>
          </li>
          <li>
            <a style="cursor:pointer;" routerLink="/points" routerLinkActive="active">
              Points
            </a>
          </li>
          <li>
            <a style="cursor:pointer;" routerLink="/traductions" routerLinkActive="active">
              Traductions
            </a>
          </li>
        </ul>
      </div>
      <div class="app">
        <div class="title">
          Mon app
        </div>
        <ul>
          <li>
            <a style="cursor:pointer;" routerLink="/langues" routerLinkActive="active">
              Langues
            </a>
          </li>
          <li>
            <a style="cursor:pointer;" routerLink="/personnalisation" routerLinkActive="active">
              Personnalisation
            </a>
          </li>
          <li>
            <a style="cursor:pointer;" routerLink="/users" routerLinkActive="active">
              Utilisateurs
            </a>
          </li>
          <li>
            <a style="cursor:pointer; text-decoration:none;" (click)="onLogout()">
              Se déconnecter
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div [className]="menuIsActive ? 'deploy hide' : 'deploy show'" (click)="deployMenu()">
    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 443.52 443.52" style="enable-background:new 0 0 443.52 443.52;" xml:space="preserve">
    	<g>
    		<g>
    			<path d="M336.226,209.591l-204.8-204.8c-6.78-6.548-17.584-6.36-24.132,0.42c-6.388,6.614-6.388,17.099,0,23.712l192.734,192.734
    				L107.294,414.391c-6.663,6.664-6.663,17.468,0,24.132c6.665,6.663,17.468,6.663,24.132,0l204.8-204.8
    				C342.889,227.058,342.889,216.255,336.226,209.591z"/>
    		</g>
    	</g>
    </svg>
  </div>
</div>
